require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-responding-to-covid-19-modern-and-resilient-agri-food.json") })
        }
      }, "path---en-us-project-responding-to-covid-19-modern-and-resilient-agri-food");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-responding-to-covid-19-modern-and-resilient-agri-food!./.cache/json/en-us-project-responding-to-covid-19-modern-and-resilient-agri-food.json
// module id = 558
// module chunks = 231608221292675